function set_mobile_menu()
{
	var viewport = viewportWidhOnLoad();
	if(viewport.width < 1024){
		jQuery('#mobile-menu-section').css('display','block');
		jQuery('#mobile-menu-section .mobile-menu-section-inner').css('display','none');
		jQuery('#mobile-menu-section .mobile-menu-tab-info').css('display','none');
	}else{
		jQuery('#mobile-menu-section').css('display','none');
		jQuery('#mobile-menu-section .mobile-menu-section-inner').css('display','none');
		jQuery('#mobile-menu-section .mobile-menu-tab-info').css('display','none');
	}
}

jQuery(document).ready(function(){
	/* mobile menu setup */
	if(jQuery('#mobile-menu-section').length > 0){
     //set_mobile_menu();
 	}

 	jQuery('#mobile-menu-section .mobile-menu-toggle').click(function(){
		if(jQuery('#mobile-menu-section').is(":visible")){
      jQuery(this).toggleClass('mobile-menu-open');
      jQuery('#mobile-menu-section .mobile-menu-section-inner').slideToggle();

 			if(jQuery(this).hasClass('mobile-menu-open')){
 				jQuery(document).mouseup(function (e) {
          var container = jQuery('#mobile-menu-section');
          if (!container.is(e.target) && container.has(e.target).length === 0)
          {
            jQuery('#mobile-menu-section .mobile-menu-toggle').toggleClass('mobile-menu-open');
            jQuery('#mobile-menu-section .mobile-menu-section-inner').slideToggle();
            jQuery(document).unbind('mouseup');
            jQuery('body').css('overflow','inherit');
            jQuery('body').css('height','inherit');
          }
        });
 				/*jQuery('#mobile-menu-section .mobile-menu-section-inner').height(jQuery(window).height());*/
 				jQuery('body').css('overflow','hidden');
 				jQuery('body').css('height','100%');
 			}else{
 				/*jQuery('#mobile-menu-section .mobile-menu-section-inner').height('auto');*/
 				jQuery(document).unbind('mouseup');
				jQuery('body').css('overflow','inherit');
 				jQuery('body').css('height','inherit');
 			}
 		}
 	});

 	jQuery('#mobile-menu-section .mobile-client-tabs li').click(function(){
 		var divId = jQuery(this).attr('data-id');
 		jQuery('#mobile-menu-section .mobile-menu-tab-info.active-div').fadeOut().removeClass('active-div');
 		
 		if(!jQuery('#mobile-menu-section .mobile-menu-section-inner').hasClass('mobile-menu-solutions'))
 		{
 			jQuery('#mobile-menu-section .mobile-menu-section-inner').addClass('mobile-menu-solutions');
 		}
 		jQuery('#mobile-menu-section #'+divId+'.mobile-menu-tab-info').fadeIn().addClass('active-div');
 	});

 	jQuery('#mobile-menu-section .mobile-menu-tab-info .menu-back').click(function(){
 		jQuery('#mobile-menu-section .mobile-menu-tab-info.active-div').fadeOut().removeClass('active-div');
 			jQuery('#mobile-menu-section .mobile-menu-section-inner').removeClass('mobile-menu-solutions');
 	});

 	/* new menu scripts */
 	jQuery('.nav-primary__right .mobile-menu-toggle').click(function(){
			jQuery(this).toggleClass('mobile-menu-open');
 			jQuery('.nav-primary__right #menu-main-menu').fadeToggle('slow');
 			if(jQuery(this).hasClass('mobile-menu-open')){
 				jQuery('.nav-primary__right #menu-main-menu').height(jQuery(window).height());
 				jQuery('body').css('overflow','hidden');
 				/*jQuery('body').css('height','100vh');*/
 				jQuery('.nav-primary__right .search-form-container').addClass('hide');
 			}else{
 				jQuery('.nav-primary__right #menu-main-menu').height('auto');
 				jQuery('body').css('overflow','inherit');
 				/*jQuery('body').css('height','auto');*/
 				jQuery('.nav-primary__right .search-form-container').removeClass('hide');
 			}
 	});

 	/*add active class to menu */
 	var path = location.href;
 	path = path.replace(baseurl,'');

 	var pathsplit = path.split("/");

 	var checkpath = pathsplit[pathsplit.length - 1];
 	if(checkpath.length <= 0){
 		checkpath = pathsplit[pathsplit.length - 2];
 	}

 	if(checkpath.length > 0){
 		jQuery('.nav-primary__right a[href*="/' + checkpath + '"]').parent('li').addClass('active');
	}

 	/*show menu section in desktop */
 	var viewport = viewportWidhOnLoad();
	if(viewport.width <= 960){
		jQuery('.nav-primary__right .search-form-container').removeClass('hide');
	}
});

jQuery(window).resize(function(){
	if(jQuery('#mobile-menu-section').length > 0){
		//set_mobile_menu();
 	}

 	/*show menu section in desktop */
 	var viewport = viewportWidhOnLoad();
 	/*console.log('resize');*/
	if(viewport.width <= 960){
		jQuery('.nav-primary__right .search-form-container').removeClass('hide');
	}
});